import React, {useEffect, useRef, useState} from "react";
import Container from "react-bootstrap/Container";
import {Alert, Breadcrumb, Col, Collapse, Row, Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import ScheduleItem from "./schedule.item.component";
import ScheduleService from "../../services/schedule.service";
import PFFinale from "../../common/pfFinale";
import VENUE_NOTES from "../../common/venueNotes";

const Schedule = ({rainDate}) => {

    const [scheduledVenues, setScheduledVenues] = useState([])
    const [mapOpen, setMapOpen] = useState(false)
    const [headerStuck, setHeaderStuck] = useState(false)
    const sentinelRef = useRef(null)

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setHeaderStuck(!entry.isIntersecting),
            {threshold: 0, rootMargin: '-56px 0px 0px 0px'}
        );
        if (sentinelRef.current) observer.observe(sentinelRef.current);
        return () => observer.disconnect();
    }, []);

    const fetchSchedule = () => {
        ScheduleService.getSchedule(rainDate).then(
            response => {
                setScheduledVenues(response.data.data);
                console.log("scheduledVenues:" + JSON.stringify(response.data.data));
            },
            error => {
                console.log(error);
            });
    }

    // load once on mount
    useEffect(() => {
        fetchSchedule();
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <h3>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Schedule</Breadcrumb.Item>
                            </Breadcrumb>
                        </h3>
                    </Col>
                </Row>
                {/*<Row className="mb-3">*/}
                {/*    <Col>*/}
                {/*        <PastPFDateAndDesc/>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                <Row className="mb-3">
                    <Col>
                        <button
                            className="btn btn-primary"
                            onClick={() => setMapOpen(o => !o)}
                            aria-expanded={mapOpen}
                        >
                            <i className={`bi ${mapOpen ? 'bi-chevron-up' : 'bi-map'} me-2`}/>
                            {mapOpen ? 'Hide map' : 'Show map'}
                        </button>
                    </Col>
                </Row>
                <Collapse in={mapOpen}>
                    <Row className="mb-2">
                        <Col>
                            <iframe title="Porchfest 2025 Map"
                                className="resp-map"
                                src="https://www.google.com/maps/d/embed?mid=1e54_q70tKhDob1ex-3IZbJ7Y2Vd52os&ehbc=2E312F&noprof=1">
                                <p>Loading map...</p>
                            </iframe>
                        </Col>
                    </Row>
                </Collapse>
                <Row>
                    <Col>
                        <Alert variant="primary">
                            <PFFinale/>
                        </Alert>
                    </Col>
                </Row>
                <div ref={sentinelRef}/>
                <Row className="mb-3">
                    <Col>
                        <Table bordered hover size="lg" className={`schedule-table${headerStuck ? ' header-stuck' : ''}`}>
                            <thead>
                            <tr>
                                <th>Location</th>
                                <th width="16%">12pm - 1pm</th>
                                <th width="16%">1pm - 2pm</th>
                                <th width="16%">2pm - 3pm</th>
                                <th width="16%">3pm - 4pm</th>
                                <th width="16%">4pm - 5pm</th>
                            </tr>
                            </thead>

                            <tbody>
                            {scheduledVenues.length > 0 &&
                                scheduledVenues.map((si) => (
                                        <tr key={si.id}>
                                            <td>
                                                <Link to={si.address_url} target="_blank"
                                                      reloadDocument="true">
                                                    <span style={{textTransform: 'capitalize'}}>{si.address}</span>
                                                </Link>
                                                {!rainDate &&
                                                    <>
                                                        <br/>
                                                        <span className="schedule-act-desc">
                                                        <strong>Rain date</strong>:&nbsp;
                                                            {si.rain_date_available &&
                                                                <span>Available</span>
                                                            }
                                                            {!si.rain_date_available &&
                                                                <span>Unavailable</span>
                                                            }
                                                        </span>
                                                    </>
                                                }
                                                {VENUE_NOTES[si.id] &&
                                                    <Alert variant="warning" className="p-1 mt-2 mb-0" style={{fontSize: '0.75rem', color: '#c0392b'}}>
                                                        <i className="bi bi-exclamation-triangle-fill me-1"/>
                                                        {VENUE_NOTES[si.id]}
                                                    </Alert>
                                                }
                                            </td>
                                            {si.slot_1 !== null &&
                                                <td className="schedule-td">
                                                    <ScheduleItem siSlot={si.slot_1} showActRainDate={!rainDate}/>
                                                </td>
                                            }
                                            {si.slot_1 == null &&
                                                <td className="schedule-td-unavailable"></td>
                                            }

                                            {si.slot_2 !== null &&
                                                <td className="schedule-td">
                                                    <ScheduleItem siSlot={si.slot_2} showActRainDate={!rainDate}/>
                                                </td>
                                            }
                                            {si.slot_2 == null &&
                                                <td className="schedule-td-unavailable"></td>
                                            }

                                            {si.slot_3 !== null &&
                                                <td className="schedule-td">
                                                    <ScheduleItem siSlot={si.slot_3} showActRainDate={!rainDate}/>
                                                </td>
                                            }
                                            {si.slot_3 == null &&
                                                <td className="schedule-td-unavailable"></td>
                                            }

                                            {si.slot_4 !== null &&
                                                <td className="schedule-td">
                                                    <ScheduleItem siSlot={si.slot_4} showActRainDate={!rainDate}/>
                                                </td>
                                            }
                                            {si.slot_4 == null &&
                                                <td className="schedule-td-unavailable"></td>
                                            }

                                            {si.slot_5 !== null &&
                                                <td className="schedule-td">
                                                    <ScheduleItem siSlot={si.slot_5} showActRainDate={!rainDate}/>
                                                </td>
                                            }
                                            {si.slot_5 == null &&
                                                <td className="schedule-td-unavailable"></td>
                                            }
                                        </tr>
                                    )
                                )
                            }
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Alert variant="primary" className="text-center">
                            <i className="bi bi-music-note-beamed"></i>{" "}
                            <strong>Porchfest Finale</strong>: The Blues Chasers at The Griffin Museum Terrace at 5:30pm{" "}
                            <i className="bi bi-music-note-beamed"></i>
                        </Alert>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Schedule;
